module.exports = __webpack_public_path__ + "img/mypic.d687438.jpg";